import UserDetails from './components/UserDetails';
export default UserDetails;
